import Backbone from 'backbone';

var User_Identification = Backbone.Model.extend({
    defaults: {
        account_id     : 0,
        identification : '',
        display_name   : '',
        email          : '',
        first_seen     : 0,
        last_seen      : 0,
        last_location  : ''
    }
});

export default User_Identification;